import store from '@client/redux/store'
import { fetchSession } from '@client/redux/actions/session'

store.dispatch(fetchSession())
